import React, { useEffect, useContext, useReducer } from "react";
import reducer from "../reducers/filter_reducer";
import {
	LOAD_PRODUCTS,
	SET_GRIDVIEW,
	SET_LISTVIEW,
	UPDATE_SORT,
	SORT_PRODUCTS,
	UPDATE_FILTERS,
	FILTER_PRODUCTS,
	CLEAR_FILTERS,
} from "../actions";
import { useProductsContext } from "./products_context";

const initialState = {
	filtered_products: [],
	all_products: [],
	gridView: false,
	sort: "name-a",
	filters: {
		text: "",
		company: "all",
		category: "all",
		color: "all",
		minPrice: 0,
		maxPrice: 0,
		price: 0,
		shipping: false,
	},
};

const FilterContext = React.createContext();
export const FilterProvider = ({ children }) => {
	const { products } = useProductsContext();
	const [state, dispatch] = useReducer(reducer, initialState);

	const setGridView = () => {
		dispatch({ type: SET_GRIDVIEW });
	};
	const setListView = () => {
		dispatch({ type: SET_LISTVIEW });
	};
	const upadteSort = (e) => {
		//for demo only
		const value = e.target.value;
		dispatch({ type: UPDATE_SORT, payload: value });
	};

	useEffect(() => {
		dispatch({ type: LOAD_PRODUCTS, payload: products });
	}, [products]);
	useEffect(() => {
		dispatch({ type: SORT_PRODUCTS });
		dispatch({ type: FILTER_PRODUCTS });
	}, [products, state.sort, state.filters]);
	const updateFilters = (e) => {
		let name = e.target.name;
		let value = e.target.value;
		if (name === "category") value = e.target.textContent;
		else if (name === "color") value = e.target.dataset.color;
		else if (name === "price") value = +value;
		else if (name === "shipping") value = e.target.checked;
		dispatch({ type: UPDATE_FILTERS, payload: { name, value } });
		dispatch({ type: FILTER_PRODUCTS });
	};
	const clearFilters = () => {
		dispatch({ type: CLEAR_FILTERS, payload: initialState.filters });
	};
	return (
		<FilterContext.Provider
			value={{
				...state,
				updateFilters,
				clearFilters,
				setGridView,
				setListView,
				upadteSort,
			}}
		>
			{children}
		</FilterContext.Provider>
	);
};
// make sure use
export const useFilterContext = () => {
	return useContext(FilterContext);
};
